function i(r, ...e) {
  if (Array.isArray(r))
    r.forEach((a) => i(a, ...e));
  else
    return r(...e);
}
export {
  i as call
};
